import { render, staticRenderFns } from "./mfms.vue?vue&type=template&id=2c051e46"
import script from "./mfms.vue?vue&type=script&lang=js"
export * from "./mfms.vue?vue&type=script&lang=js"
import style0 from "./mfms.vue?vue&type=style&index=0&id=2c051e46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports